import {QueueItemType} from "@/types";
import React, {ReactElement, RefObject, useCallback} from "react";
import QueueItem from "@/components/Queue/QueueItem";
import Loading from "@/components/Loading/Loading";

export interface QueueItemsProps {
    queueItems: QueueItemType[];
    limitedAccess?: boolean;
    _ref?: RefObject<any>;
    prePendedQueueItems?: () => (ReactElement | null)[];
}

export default function QueueItems({
                                       _ref,
                                       queueItems,
                                       limitedAccess,
                                       prePendedQueueItems = () => []
                                   }: QueueItemsProps) {
    const buildQueueItems = useCallback(() => {
        return queueItems.length > 0
            ? queueItems.map<ReactElement>((queueItem: any, key: number) => {
                return (
                    <QueueItem key={key}
                               index={key}
                               limitedAccess={limitedAccess}
                               data={queueItem}/>
                );
            })
            : <li className="flex flex-1 justify-center bg-dark-black"><Loading/></li>
    }, [queueItems]);

    return (
        <div className="border-primary mx-auto max-h-[1400px] h-full">
            {prePendedQueueItems()}
            <ul ref={_ref} id="the-queue" className="overflow-y-scroll overflow-x-hidden max-h-full ml-0">
                {buildQueueItems()}
            </ul>
        </div>
    );
}
